import type { JSX } from 'react';

export default function Footer(): JSX.Element {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-neutral-200 px-4 py-8 text-center text-sm text-neutral-500">
      <p>© {year} Shaping Colours. All rights reserved.</p>
      <p className="mt-1">Built by Anirudh &amp; Prabhav.</p>
    </footer>
  );
}
